<template>
    <div class="top-panel container-fluid">
      <div class="col-sm">
        <router-link to="/"><img id="logo" src="../assets/pg-logo.png" alt="Practigame"></router-link>
      </div>
    </div>
</template>

<script>
    export default {
        name: "Header"
    }
</script>

<style scoped>
  .top-panel {
    background: rgba(0, 0, 0, 0.3);
    text-align: center;
    padding-left: 0;
    padding-right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue